import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { useRef as P, useContext as S, useEffect as $ } from "react";
import { useTranslation as w } from "react-i18next";
import "../../components/Breadcrumbs/index.js";
import "../../components/Button/index.js";
import "classnames";
import "reactjs-popup";
import { ThemeContext as q } from "../../components/ThemeContext/index.js";
import "../../modal-l0sNRNKZ.js";
import "../../fields/Input/index.js";
import "../../components/Tooltip/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../fields/Select/index.js";
import "react-dropzone";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "../../fields/Wysiwyg/index.js";
import "../../fillDocument/FillForm/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import { calculateProductValues as j, calculateTotalValues as B } from "../../helpers/productsCalcFunctions.js";
import { mapProductToData as F, mapTotalForCalc as L } from "../../helpers/mapProductsToFilling.js";
const V = "forma-ui__editor-products-table__root", k = "forma-ui__editor-products-table__headCell", T = {
  root: V,
  headCell: k
}, A = (m) => {
  const C = m.offsetWidth, b = Array.from(m.getElementsByTagName("th")), x = [];
  for (const i of b) {
    const c = i, h = (c.offsetWidth * 100 / C).toFixed(2);
    c.style.width = h + "%", x.push(h + "%");
  }
  return x;
}, Nt = ({
  id: m,
  name: C,
  sideId: b,
  resized: x,
  columns: i,
  total: c,
  showTotalRow: h,
  cellStyles: l,
  onChange: W,
  products: _
}) => {
  const d = P(null), { t: y } = w(), { currencies: v, lang: z } = S(q), f = v && v[z], r = {
    pageX: 0,
    curColIndex: null,
    curColWidth: 0,
    nxtColWidth: 0
  }, I = (t) => {
    var N;
    const o = t.target;
    if (!d.current || !o.classList.contains("products-table-resizer"))
      return;
    t.preventDefault();
    const e = d.current.offsetWidth;
    r.curColIndex = Number((N = o.parentElement) == null ? void 0 : N.dataset.index);
    const n = d.current.querySelector(`th:nth-child(${r.curColIndex + 1})`), a = n.nextElementSibling;
    r.pageX = t.pageX, r.curColWidth = n.offsetWidth * 100 / e, a && (r.nxtColWidth = a.offsetWidth * 100 / e);
  }, E = (t) => {
    if (!d.current || r.curColIndex === null)
      return;
    t.preventDefault();
    const o = d.current.offsetWidth, e = (t.pageX - r.pageX) * 100 / o;
    if (r.nxtColWidth - e > 5 && r.curColWidth + e > 5) {
      const n = d.current.querySelector(`th:nth-child(${r.curColIndex + 1})`), a = n.nextElementSibling;
      n.style.width = r.curColWidth + e + "%", a && (a.style.width = r.nxtColWidth - e + "%");
    }
  }, X = (t) => {
    var o;
    if (d.current && r.curColIndex !== null) {
      t.preventDefault();
      const e = [...i], n = (o = d.current) == null ? void 0 : o.querySelector(`th:nth-child(${r.curColIndex + 1})`);
      if (n) {
        e[r.curColIndex] = { id: e[r.curColIndex].id, name: n.innerText, width: n.style.width };
        const a = n.nextElementSibling;
        a && (e[r.curColIndex + 1] = { id: e[r.curColIndex + 1].id, name: a.innerText, width: a.style.width }), W(b, { id: m, name: C, columns: e, total: c, showTotalRow: h, resized: !0 });
      }
    }
    r.curColIndex = null, r.pageX = 0, r.nxtColWidth = 0, r.curColWidth = 0;
  }, D = (t, o) => {
    if (r.curColIndex !== null)
      return;
    const e = [...i];
    e[o] = { ...e[o], name: t.target.innerText }, W(b, { id: m, name: C, columns: e, total: c, showTotalRow: h, resized: !0 });
  };
  $(() => {
    if (!x && d.current && d.current.offsetWidth) {
      const t = A(d.current), o = i.map((e, n) => ({ ...e, width: t[n] }));
      W(b, { id: m, name: C, columns: o, total: c, showTotalRow: h, resized: !0 });
    }
  }, [x, d]);
  const g = _ == null ? void 0 : _.map((t, o) => j({
    ...F(t, i.map(({ id: e }) => e)),
    category: t.category.name,
    number: o + 1 + "",
    count: "1"
  }, f == null ? void 0 : f.code)), M = c.map(({ id: t }) => t), p = g && B(g, L({}, M, h), f == null ? void 0 : f.code);
  return /* @__PURE__ */ u("div", { className: T.root, children: [
    /* @__PURE__ */ u(
      "table",
      {
        onMouseDown: I,
        onMouseMove: E,
        onMouseUp: X,
        "data-cke-ignore-events": "true",
        ref: d,
        children: [
          !!(i != null && i.length) && /* @__PURE__ */ s("thead", { children: /* @__PURE__ */ s("tr", { children: i.map(({ id: t, name: o, width: e }, n) => /* @__PURE__ */ s(
            "th",
            {
              id: t,
              className: T.headCell,
              onBlur: (a) => D(a, n),
              style: l ? {
                borderStyle: l.borderStyle,
                borderColor: l.borderColor,
                borderWidth: l.borderWidth,
                width: e
              } : {
                width: e
              },
              role: "textbox",
              contentEditable: "true",
              "aria-multiline": "true",
              colSpan: i.length === 1 && p && c.length ? 2 : void 0,
              dangerouslySetInnerHTML: {
                __html: n < i.length - 1 ? o + '<span class="products-table-resizer"></span>' : o
              },
              "data-index": n
            },
            t
          )) }) }),
          /* @__PURE__ */ u("tbody", { children: [
            g == null ? void 0 : g.map((t, o) => /* @__PURE__ */ s("tr", { children: i.map(({ id: e }, n) => /* @__PURE__ */ u(
              "td",
              {
                "data-index": n,
                colSpan: i.length === 1 && p && c.length ? 2 : void 0,
                style: l && {
                  borderStyle: l.borderStyle,
                  borderColor: l.borderColor,
                  borderWidth: l.borderWidth
                },
                children: [
                  t[e],
                  n < i.length - 1 && /* @__PURE__ */ s("span", { className: "products-table-resizer", onMouseDown: I })
                ]
              },
              `${t.id}_${e}`
            )) }, o)),
            !!p && c.map(({ id: t, name: o }) => t === "rowTotalCountPrice" ? null : /* @__PURE__ */ u("tr", { className: "products-table-row-total", children: [
              /* @__PURE__ */ u("td", { "data-index": i.length - 2, colSpan: i.length - 1, children: [
                o,
                /* @__PURE__ */ s("span", { className: "products-table-resizer", onMouseDown: I })
              ] }),
              /* @__PURE__ */ s(
                "td",
                {
                  style: l && {
                    borderStyle: l.borderStyle,
                    borderColor: l.borderColor,
                    borderWidth: l.borderWidth
                  },
                  children: p[t]
                }
              )
            ] }, t))
          ] })
        ]
      }
    ),
    h && !!p && /* @__PURE__ */ u("div", { className: "products-table-footer", children: [
      y("total_names_for_price", { items: p.totalCountItems, price: p.totalPrice }),
      /* @__PURE__ */ s("br", {}),
      /* @__PURE__ */ s("b", { children: y("price_in_words") })
    ] })
  ] });
};
export {
  Nt as default
};
